import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../components/MaterialTypography";
import {
  Avatar,
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  ListItemButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Pagination,
  Stack,
  Breadcrumbs,
  Typography,
} from "@mui/material";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FolderIcon from "@mui/icons-material/Folder";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { BASE_URL, postData } from "../Utils/Baseurl";
import { useLoading } from "../../context/loadingcontext";
import MaterialSelect from "../../components/MaterialSelect";
import ChatBot from "../chatbot";
import NewFolder from "../../components/NewFolder";
import NewFile from "../../components/NewFile";
import MaterialButton from "../../components/MaterialButton";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";



const Documents = () => {
  const [contextMenu, setContextMenu] = useState(null);



  const { setCirleLoading } = useLoading();

  const [project, setProject] = useState([]);
  const [task, setTask] = useState({ label: "All", value: "All" });
  const [projectStatus, setProjectStatus] = useState({
    label: "All",
    value: "All",
  });
  const [projectType, setProjectType] = useState([]);
  const [status, setStatus] = useState([]);
  const [parent, setparent] = useState("");

  const [projectid, setprojectid] = useState(0);

  const [folderList, setFolderList] = useState([]);
  const [SubfolderList, setSubFolderList] = useState([]);

  const [fileList, setFileList] = useState([]);
  const [currentFolder, setCurrentFolder] = useState(null);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState("");

  const [files, setfiles] = useState([])
  const [newFolder, setNewFolder] = useState({
    folder_name: "Admin Project Folder 1",
    parent: null,
    project_id: 41,
    readPermission: [],
    writePermission: [],
  });

  const [newFile, setNewFile] = useState({
    project: parent,
    name: "",
    file: [],
    parent: null,
    readPermission: [],
    writePermission: [],
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [teamMembersData, setTeamMembersData] = useState([]);
  const [validateFile, setValidateFile] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const [chatBotStatus, setChatBotStatus] = useState(false);
  const [suggestion, setSuggestion] = useState("");

  const [menuAnchor, setMenuAnchor] = useState(null);

  const [breadcrumbPath, setBreadcrumbPath] = useState([]);


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProjects = project.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(project.length / itemsPerPage);

  useEffect(() => {
    fetchProjectStatus();
    fetchProjectType();
    fetchTeamMembers();
  }, []);

  useEffect(() => {
    fetchProjectData();
    fetchChatList();
  }, [projectStatus, task]);

  useEffect(() => {
    if (currentFolder) {
      fetchFileDatas(currentFolder.id)
    }
  }, []);



  const fetchFileDatas = async (id) => {
    setUploadDialogOpen(true);
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`${BASE_URL}api/documentfolder/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      console.log(data, "data");
      setfiles(data?.data)
      setFolderList(data.data[0]?.sub_folder || []);
    } catch (error) {
      console.error("Error fetching file data:", error);
    }
  };


  const fetchProjectType = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`${BASE_URL}api/ProjectType/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      const types = data.data.map((item) => ({
        value: item.id,
        label: item.projecttype,
      }));
      setProjectType([{ label: "All", value: null }, ...types]);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchProjectStatus = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`${BASE_URL}api/Status/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      const statuses = data?.data?.map((item) => ({
        value: item.id,
        label: item.status,
      }));
      setStatus([{ label: "All", value: null }, ...statuses]);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchProjectData = async () => {
    setCirleLoading(true);
    try {
      const formdata = {
        project_type: task?.label === "All" ? "" : task?.label,
        status: projectStatus?.label === "All" ? "" : projectStatus?.label,
      };
      const response = await postData("api/project/filter/", formdata);
      setProject(response?.data || []);
      setCurrentPage(1);
    } catch (err) {
      console.error(err)
    } finally {
      setCirleLoading(false);
    }
  };

  const fetchChatList = async () => {
    setCirleLoading(true);
    try {
      const res = await postData("ai/ManagerProjectAnalysis/");
      setChatBotStatus(true);
      setSuggestion(res?.analysis || res?.message);
    } catch (err) {
      setSuggestion("");
      setChatBotStatus(false);
    } finally {
      setCirleLoading(false);
    }
  };





  useEffect(() => {
    const savedFolders = sessionStorage.getItem("folderList");
    const savedFiles = sessionStorage.getItem("fileList");
    if (savedFolders) setFolderList(JSON.parse(savedFolders));
    if (savedFiles) setFileList(JSON.parse(savedFiles));
  }, []);

  useEffect(() => {
    sessionStorage.setItem("folderList", JSON.stringify(folderList));
  }, [folderList]);

  useEffect(() => {
    sessionStorage.setItem("fileList", JSON.stringify(fileList));
  }, [fileList]);




  const getCurrentItems = () => {
    return folderList

  };



  const handleOpenFolder = async (folder) => {
    setCurrentFolder(folder);


    setBreadcrumbPath((prev) => {
      const exists = prev.find((f) => f.id === folder.id);
      if (exists) return prev;
      return [...prev, folder];
    });

    if (folder.id) {
      setCirleLoading(true);
      try {
        const token = sessionStorage.getItem("token");
        const res = await fetch(`${BASE_URL}api/documentfolder/${folder.id}/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        console.log(data, "data");
        setfiles(data?.data)
        setFolderList(data.data[0]?.sub_folder || []);
      } catch (err) {
        console.error(err);
      } finally {
        setCirleLoading(false);
      }
    }
  };


  const handleBreadcrumbClick = async (folder) => {
    if (folder === null) {

      setCurrentFolder(null);
      setBreadcrumbPath([]);
      await fetchFolders();
      return;
    }


    setCurrentFolder(folder);
    setBreadcrumbPath((prev) => {
      const index = prev.findIndex((f) => f.id === folder.id);
      return prev.slice(0, index + 1);
    });

    await handleOpenFolder(folder);
  };

  useEffect(() => {
    fetchTeamMembers();

  }, []);

  const fetchTeamMembers = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${BASE_URL}api/create_user/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const transformedData = data.data.map((item) => ({
        id: item.id,
        // employee_name: `${item?.firstName || ""} ${item?.lastName || ""}`,
        employee_name: item.employee_name,
        // team: item.designation,
        team: item.team?.team_name,
      }));
      setTeamMembersData(transformedData);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };


  const handleGoBack = async () => {
    if (breadcrumbPath.length > 0) {

      const updatedPath = [...breadcrumbPath];
      updatedPath.pop();


      const previousFolder = updatedPath[updatedPath.length - 1] || null;

      setBreadcrumbPath(updatedPath);
      setCurrentFolder(previousFolder);

      if (previousFolder) {
        await handleOpenFolder(previousFolder);
      } else {

        await fetchFolders();
      }
    } else {

      setCurrentFolder(null);
      await fetchFolders();
    }
  };





  const handleMenuClick = (type) => {
    setDialogType(type);
    setDialogOpen(true);
    setMenuAnchor(null);
    if (type === "folder") setNewFolder((prev) => ({ ...prev, parent: currentFolder?.id || null }));
    if (type === "file") setNewFile((prev) => ({ ...prev, parent: currentFolder?.id || null }));
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setDialogType("");
    setNewFolder({

      name: "",
      parent: null,
      readPermission: [],
      writePermission: [],
    });
    setNewFile({

      name: "",
      project: "",
      file: [],
      parent: null,
      readPermission: [],
      writePermission: [],
    });
  };




  const handleItemRightClick = (event, item, type) => {
    event.preventDefault();
    setContextMenu({
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 4,
      item,
      type,
    });
  };



  const handleContextMenuAction = async (action) => {
    if (!contextMenu) return;
    const { item, type } = contextMenu;

    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    try {
      if (action === "edit") {
        console.log("item", item)
        if (type === "folder") {
          

          setDialogType("folder");
          setNewFolder({
            id: item.id,
            name: item.folder_name,
            parent: item.parent || null,
            
            readPermission:
          item.read_permission?.map((item) => ({
            id: item.user_id,
            employee_name: item.username,
          })) || [],
            writePermission:
          item.write_permission?.map((item) => ({
            id: item.user_id,
            employee_name: item.username,
          })) || [],
          });
          setDialogOpen(true);
        } else if (type === "file") {
          // File edit (fetch file data)
          await fetchFileData(item.id);
          setDialogType("file");
          setDialogOpen(true);
        }
      }

      // if (action === "open" && type === "file") {
      //   // Open file in new tab
      //   if (item.document) {
      //     window.open(item.document, "_blank");
      //   } else {
      //     const res = await axios.get(`${BASE_URL}api/documents/${item.id}/`, { headers });
      //     const data = res.data?.data;
      //     if (data?.document) window.open(data.document, "_blank");
      //   }
      // }

      if (action === "delete") {
        if (type === "folder") {

          await axios.delete(`${BASE_URL}api/documentfolder/${item.id}/`, { headers });
          if (currentFolder == null) {
            await fetchFolders();
          }
          else {
            await fetchFileDatas(currentFolder.id)
          }
        } else if (type === "file") {

          await axios.delete(`${BASE_URL}api/documents/${item.id}/`, { headers });
          await fetchFileDatas(currentFolder.id);
        }
      }

      if (action === "download" && type === "file") {
        // Download file
        const fileUrl = item.document || (await (await axios.get(`${BASE_URL}api/documents/${item.id}/`, { headers })).data?.data?.document);
        if (fileUrl) {
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = item.document_name || "document";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    } catch (error) {
      console.error(`Error handling ${action} for ${type}:`, error);
    } finally {
      setContextMenu(null);
    }
  };


  const fetchFolders = async () => {
    setCirleLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`${BASE_URL}api/documentfolder/?project_id=${projectid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      console.log(data, "data");

      setFolderList(data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    if (projectid != 0) {
      fetchFolders();
    }
  }, [projectid]);

  useEffect(() => {
    fetchSubFolders()
  }, [])



  const fetchSubFolders = async (id) => {
    setCirleLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const res = await fetch(`${BASE_URL}api/documentfolders/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      console.log(data, "data");

      setSubFolderList(data.data?.sub_folder || []);
    } catch (err) {
      console.error(err);
    } finally {
      setCirleLoading(false);
    }
  };



  const handleAddNewFolder = async () => {
    const token = sessionStorage.getItem("token");
    const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    // const user = currentUser;

    if (newFolder.id) {
      const payload = {
        folder_name: newFolder.name,
        upload_by: currentUser,
        parent: currentFolder == null ? null : currentFolder?.id,
        read_permission: parseInt(newFolder.readPermission.map(u => u.id, currentUser)),
        write_permission: parseInt(newFolder.writePermission.map(u => u.id, currentUser)),
        project_id: projectid,
      };
      //newFolder.readPermission.map(u => ({ user_id: u.id })), 

      try {
        setCirleLoading(true);
        await fetch(`${BASE_URL}api/documentfolder/${newFolder.id}/`, { method: "PUT", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, body: JSON.stringify(payload) });
        if (currentFolder == null) {
          fetchFolders();

        }
        else {
          fetchFileDatas(currentFolder?.id)
        }
      } catch (err) {
        console.error(err);
      } finally {
        handleDialogClose();
        setCirleLoading(false);
      }
    }
    else {
      const payload = {
        folder_name: newFolder.name,
        parent: currentFolder == null ? null : currentFolder?.id,
        read_permission: [
          ...newFolder.readPermission.map(u => parseInt(u.id)),
          parseInt(currentUser),
        ],
        write_permission: [
          ...newFolder.writePermission.map(u => parseInt(u.id)),
          parseInt(currentUser),
        ],
        project_id: projectid,
      };
      try {
        setCirleLoading(true);
        await fetch(`${BASE_URL}api/documentfolder/`, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, body: JSON.stringify(payload) });
        if (currentFolder == null) {
          fetchFolders();
        }
        else {
          fetchFileDatas(currentFolder?.id)
        }
      } catch (err) {
        console.error(err);
      } finally {
        handleDialogClose();
        setCirleLoading(false);
      }
    }

  };

  const handleUpload = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
      const userId = currentUser ? parseInt(currentUser) : null;

      const formData = new FormData();
      formData.append("folder", selectedFolder || currentFolder?.id || "");
      formData.append("project", projectid);
      formData.append("document_name", newFile.name || "");
      formData.append("upload_by", userId);


      if (newFile.file && newFile.file.length > 0) {
        newFile.file.forEach((file) => {
          formData.append("document", file);
        });
      }

      if (newFile.readPermission?.length > 0) {
        const readPermissions = newFile.readPermission.map(item => ({ user_id: item.id }));

        formData.append("read_permission", JSON.stringify(readPermissions));
      }

      if (newFile.writePermission?.length > 0) {
        const writePermissions = newFile.writePermission.map(item => ({ user_id: item.id }));
        formData.append("write_permission", JSON.stringify(writePermissions));
      }
      // setCirleLoading(true); 
      const response = newFile?.id ? await axios.put(
        `${BASE_URL}api/documents/${newFile?.id}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      ) : (await axios.post(
        `${BASE_URL}api/documents/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      ));

      console.log("Upload response:", response.data);

      setUploadDialogOpen(false);


      setNewFile({
        name: "",
        project: null,
        upload_by: "",
        readPermission: [],
        writePermission: [],
      });
      setSelectedFiles([]);
      await fetchFileDatas(currentFolder.id)
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const fetchFileData = async (id) => {
    setUploadDialogOpen(true);
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(`${BASE_URL}api/documents/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = response.data.data;
      const fileObj = {
        name: data.document || "file",
        url: data.document || "",
      };

      setNewFile({
        id: data.id,
        name: data.document_name || "",
        project: {
          value: data.project_details?.id || "",
          label: data.project_details?.name || "",
        },
        file: [fileObj],
        readPermission:
        //hh
          data.read_permission?.map((item) => ({
            id: item.user_id,
            employee_name: item.username,
          })) || [],
        writePermission:
          data.write_permission?.map((item) => ({
            id: item.user_id,
            employee_name: item.username,
          })) || [],
      });
    } catch (error) {
      console.error("Error fetching file data:", error);
    }
  };

  const drawerContent = () => {
    const items = getCurrentItems();

    console.log(items, "i332");

    return (
      <Box sx={{ p: 1 }}>
        {currentFolder && (

          <Button variant="contained" sx={{ bgcolor: "grey", color: "#000000" }} size="small" component="div" onClick={handleGoBack}>
            Back
          </Button>
        )}


        <ListItemButton
          component="div"
          onClick={() => {
            setDialogType("folder");
            setDialogOpen(true);
          }}
        >
          <ListItemIcon sx={{ color: "#000066", fontSize: "40px" }}>
            <CreateNewFolderIcon />
          </ListItemIcon>
          <MaterialTypography variant="caption" color="text">
            Add Folder
          </MaterialTypography>
        </ListItemButton>

        {/* Upload Files Button */}
        {currentFolder && (
          <ListItemButton
            component="div"
            onClick={() => {
              setDialogType("file");
              setDialogOpen(true);
              setSelectedFolder(currentFolder?.id);
            }}
          >
            <ListItemIcon sx={{ color: "#000066", fontSize: "40px" }}>
              <UploadFileIcon />
            </ListItemIcon>
            <MaterialTypography variant="caption" color="text">
              Upload files
            </MaterialTypography>
          </ListItemButton>
        )}


        {currentFolder &&
          files[0]?.documents?.map((item, index) => (
            <ListItemButton
              component="div"
              key={index}
              style={{ marginBottom: "8px" }}

              onClick={() => {

                console.log("File clicked:", item?.document_name);

              }}
              onContextMenu={(e) =>
                handleItemRightClick(e, item, item.folder_name ? "folder" : "file")
              }
            >
              <ListItemIcon sx={{ color: "skyblue", fontSize: "40px" }}>
                <InsertDriveFileIcon />
              </ListItemIcon>
              <MaterialTypography>

                {item?.document_name}

              </MaterialTypography>
            </ListItemButton>
          ))}



        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={() => setMenuAnchor(null)}
        >
          <MenuItem onClick={() => handleMenuClick("folder")}>
            Create New Folder
          </MenuItem>

          {currentFolder && (
            <MenuItem onClick={() => handleMenuClick("file")}>
              Upload File
            </MenuItem>
          )}

        </Menu>

        {/* Folders/Files */}
        {folderList.map((item) => (
          <ListItemButton
            key={item.id}
            onClick={item.folder_name ? () => handleOpenFolder(item) : undefined}
            onContextMenu={(e) =>
              handleItemRightClick(e, item, item.folder_name ? "folder" : "file")
            }
          >
            <ListItemIcon
              sx={{
                fontSize: "40px",
                color: item.folder_name ? "#0066cc" : "#009688",
              }}
            >
              {item.folder_name ? <FolderIcon /> : <InsertDriveFileIcon />}
            </ListItemIcon>
            <MaterialTypography variant="body2">
              {item.folder_name || item.name}
            </MaterialTypography>
          </ListItemButton>
        ))}

        <Menu
          open={Boolean(contextMenu)}
          onClose={() => setContextMenu(null)}
          anchorReference="anchorPosition"
          anchorPosition={
            contextMenu
              ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
              : undefined
          }
        >
          {contextMenu?.type && (
            <>
              <MenuItem onClick={() => handleContextMenuAction("edit")}>
                Edit
              </MenuItem>
              <MenuItem onClick={() => handleContextMenuAction("delete")}>
                Delete
              </MenuItem>
              {contextMenu?.type === "file" && (
                <>
                  <MenuItem onClick={() => handleContextMenuAction("download")}>
                    Download
                  </MenuItem>

                </>
              )}
            </>
          )}
        </Menu>
      </Box>
    );
  };


  const truncate = (desc) =>
    desc?.length > 25 ? `${desc.substring(0, 28)}...` : desc;


  const handleOpen = (title, id) => {
    setDrawerOpen(true);
    setSelectedProject(title);
    setprojectid(id);
    setBreadcrumbPath([]);

  };

  return (
    <DashboardLayout>
      <Box
        sx={{
          display: "flex",
          width: "90%",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Stack direction="column">
          <MaterialTypography variant="h5" fontWeight="bold" color="dark">
            Documents
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the documents here.
          </MaterialTypography>
        </Stack>
        <Box>
          <MaterialTypography variant="caption" color="text">
            Project Type
          </MaterialTypography>
          <MaterialSelect
            name="projectTask"
            value={task}
            onChange={setTask}
            options={projectType}
          />
        </Box>
        <Box>
          <MaterialTypography variant="caption" color="text">
            Project Status
          </MaterialTypography>
          <MaterialSelect
            name="projectStatus"
            value={projectStatus}
            onChange={setProjectStatus}
            options={status}
          />
        </Box>
      </Box>

      {chatBotStatus && (
        <ChatBot suggestionText={suggestion} style={{ marginTop: "-100px" }} />
      )}

      {project.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "60vh",
          }}
        ></Box>
      ) : (
        <>
          <Grid container spacing={2} sx={{ mt: 2, p: 1 }}>
            {currentProjects.map((item) => (
              <Grid size={{ xs: 12, sm: 3, md: 3 }} key={item.project_id}>
                <Card sx={{ p: 1, maxHeight: 240, zIndex: 0, cursor: "pointer" }} onClick={() => handleOpen(item.project_name, item.project_id)} >
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Avatar
                          alt="Remy Sharp"
                          src={item.project_logo}
                          sx={{
                            width: 40,
                            height: 40,
                            "& img": {
                              objectFit: "cover",
                              width: "100%",
                              height: "100%",
                            },
                          }}
                        />
                        <Stack direction="column" spacing={0}>
                          <MaterialTypography
                            variant="h6"
                            fontWeight="bold"
                            color="dark"
                            sx={{ fontSize: "12px" }}
                          >
                            {item.project_name}
                          </MaterialTypography>
                          <MaterialTypography
                            variant="caption"
                            color="text"
                            sx={{ fontSize: "10px" }}>
                            {item.project_code}
                          </MaterialTypography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} mt={1}>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <MaterialTypography
                        variant="body2"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        {truncate(item.description)}
                      </MaterialTypography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} mt={1}>
                    <Grid size={{ xs: 12, md: 12 }}>
                      <Stack direction="row" spacing={1}>
                        <Avatar
                          alt="Remy Sharp"
                          src={item.manager_profile}
                          sx={{
                            width: 30,
                            height: 30,
                            "& img": {
                              objectFit: "cover",
                              width: "100%",
                              height: "100%",
                            },
                          }} />
                        <Stack direction="column" spacing={0}>
                          <MaterialTypography
                            variant="h6"
                            fontWeight="bold"
                            color="text"
                            sx={{ fontSize: "10px" }}>
                            {item.manager}
                          </MaterialTypography>
                          <MaterialTypography
                            variant="h6"
                            fontWeight="bold"
                            color="text"
                            sx={{ fontSize: "10px" }}>
                            Project Manager
                          </MaterialTypography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} mt={1}>
                    <Grid size={{ xs: 6, lg: 6 }}>
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography
                          variant="h6"
                          fontWeight="bold"
                          color="text"
                          sx={{ fontSize: "10px" }}>
                          Start Date
                        </MaterialTypography>
                        <MaterialTypography
                          variant="h6"
                          fontWeight="bold"
                          color="text"
                          sx={{ fontSize: "10px" }}
                        >
                          {item.start_date}
                        </MaterialTypography>
                      </Stack>
                    </Grid>
                    <Grid
                      size={{ xs: 6, lg: 6 }}
                      sx={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography
                          variant="h6"
                          fontWeight="bold"
                          color="text"
                          sx={{ fontSize: "10px" }}
                        >
                          Live Date
                        </MaterialTypography>
                        <MaterialTypography
                          variant="h6"
                          fontWeight="bold"
                          color="text"
                          sx={{
                            fontSize: "10px",
                            color:
                              item.days_left < 30 && item.completion_percent < 50
                                ? "red"
                                : item.days_left < 5 &&
                                  item.completion_percent < 80
                                  ? "orange"
                                  : "green",
                            animation: "blinker 3s linear infinite",
                            "@keyframes blinker": {
                              "50%": {
                                opacity: 0,
                              },
                            },
                          }}
                        >
                          {item.end_date}
                        </MaterialTypography>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} mt={1}>
                    <Grid size={{ xs: 6, lg: 6 }}>
                      <Stack direction="row" spacing={0} alignItems="center">
                        <CalendarMonthIcon
                          sx={{ color: "#00C853", fontSize: 16 }}
                        />
                        <MaterialTypography
                          variant="body2"
                          color="text"
                          sx={{ fontSize: "10px" }}
                        >
                          {item.days_left} days left
                        </MaterialTypography>
                      </Stack>
                    </Grid>
                    <Grid
                      size={{ xs: 6 }}
                      sx={{ display: "flex", flexDirection: "row-reverse" }}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography
                          variant="body2"
                          color="text"
                          sx={{ fontSize: "10px" }}
                        >
                          Completed tasks: {item.completion_percent}%
                        </MaterialTypography>
                      </Stack>
                    </Grid>
                  </Grid>
                  {item?.status && (
                    <Box
                      sx={{
                        width: "100px",
                        height: "100px",
                        overflow: "hidden",
                        position: "absolute",
                        top: 0,
                        right: 0,
                        zIndex: -1,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          fontSize: "10px",
                          fontWeight: "bold",
                          color: "#fff",
                          textAlign: "center",
                          position: "absolute",
                          width: "140px",
                          top: "25px",
                          right: "-40px",
                          backgroundColor: item?.color || "orange",
                          padding: "2px 0",
                          transform: "rotate(45deg)",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        }}
                      >
                        {item?.status}
                      </Box>
                    </Box>
                  )}
                </Card>
              </Grid>
            ))}
          </Grid>



          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(e, page) => setCurrentPage(page)}
              color="primary"
              shape="rounded"
              siblingCount={1}
              boundaryCount={1}
            />
          </Box>
        </>
      )}


      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => { }}
        ModalProps={{ keepMounted: true, disableEscapeKeyDown: true }}
        sx={{ "& .MuiDrawer-paper": { width: 550 } }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
          <MaterialButton
            onClick={() => setDrawerOpen(false)}
            sx={{ color: "#000000", fontWeight: "bold" }}
          >
            <CloseIcon />
          </MaterialButton>
        </Box>


        <Box sx={{ color: "darkblue", px: 3, mb: 2 }}>

          <Breadcrumbs separator="›" aria-label="breadcrumb">
            <Typography
              color="inherit"
              sx={{ cursor: "pointer" }}
              onClick={() => handleBreadcrumbClick(null)}
            >
              {selectedProject}
            </Typography>
            {breadcrumbPath.map((folder, index) => (
              <Typography
                key={folder.id}
                color={index === breadcrumbPath.length - 1 ? "text.primary" : "inherit"}
                sx={{
                  cursor: index === breadcrumbPath.length - 1 ? "default" : "pointer",
                }}
                onClick={
                  index === breadcrumbPath.length - 1
                    ? undefined
                    : () => handleBreadcrumbClick(folder)
                }
              >
                {folder.folder_name}
              </Typography>
            ))}
          </Breadcrumbs>
        </Box>

        {drawerContent()}
      </Drawer>


      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {dialogType === "folder"
            ? newFolder.id
              ? "Edit Folder"
              : "Create New Folder"
            : newFile.id
              ? "Edit File"
              : "Upload New File"}
        </DialogTitle>
        <DialogContent>
          {dialogType === "folder" ? (
            <NewFolder
              newFolder={newFolder}
              setNewFolder={setNewFolder}
              teamMembersData={teamMembersData}
              handleMemberChange={(e, value) => setNewFolder({ ...newFolder, writePermission: value })}
              handleReadMemberChange={(e, value) => setNewFolder({ ...newFolder, readPermission: value })}
            />
          ) : (
            <NewFile newFile={newFile} setNewFile={setNewFile}
              selectedFiles={newFile.file}
              projectList={projectType}
              teamMembersData={teamMembersData}
              handleProjectChange={(val) => setNewFile({ ...newFile, project: val })}
              handleFileChange={(e) => setNewFile({ ...newFile, file: [...newFile.file, ...Array.from(e.target.files)] })}
              handleReadMemberFileChange={(e, value) => setNewFile({ ...newFile, readPermission: value })}
              handleWriteFileMemberChange={(e, value) => setNewFile({ ...newFile, writePermission: value })}
            />
          )}
        </DialogContent>
        <DialogActions>
          <MaterialButton
            onClick={() => {

              setNewFile({
                id: null,
                name: "",
                file: [],
                project: "",

              });
              setNewFolder({
                id: null,
                name: "",
              });
              handleDialogClose();
            }}
          >
            Cancel
          </MaterialButton>

          <MaterialButton
            onClick={async () => {
              if (dialogType === "folder") {
                await handleAddNewFolder();
              } else {
                await handleUpload();
              }

              setNewFile({
                id: null,
                name: "",
                file: [],
                project: "",
              });
              setNewFolder({
                id: null,
                name: "",
              });
              handleDialogClose();
            }}
          >
            {dialogType === "folder"
              ? newFolder.id
                ? "Update"
                : "Create"
              : newFile.id
                ? "Update"
                : "Upload"}
          </MaterialButton>
        </DialogActions>

      </Dialog>
    </DashboardLayout>
  );
};

export default Documents;
